import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import SectionRenderer from './SectionRenderer';

const StackedPortfolioLayout = ({ siteConfig }) => {
  const order = Array.isArray(siteConfig?.sectionOrder) && siteConfig.sectionOrder.length
    ? siteConfig.sectionOrder
    : ['hero', 'about', 'projects', 'skills', 'experience', 'contact'];
  const visibility = siteConfig?.sectionVisibility || {};

  return (
    <>
      <Header />
      <main>
        {order.map((sectionKey) => {
          if (visibility[sectionKey] === false) {
            return null;
          }

          return <SectionRenderer key={sectionKey} sectionKey={sectionKey} />;
        })}
      </main>
      {visibility.footer !== false && <Footer />}
    </>
  );
};

export default StackedPortfolioLayout;
